module.exports = __webpack_public_path__ + "img/Slide15.ba9b89ce.png";